export const WhatsOnGenreNoResults = () => (
  <div className="no-results">
    <h2 className="h3">Sorry! We couldn't find any events that match your query.</h2>
    <h3 className="h4 color-grey">Try removing some filters and/or select a different date.</h3>
    <hr />
    <p className="h4">
      If it helps, here are some other events we think you might be interested in...
    </p>
  </div>
);
